import { ActionLink } from '@cian/ui-kit/link';
import { Theme } from '@cian/ui-kit/theme';
import * as React from 'react';

import * as styles from './YmapsBlockedToast.css';

export const YMAPS_BLOCKED_TOAST_TEXT = 'Карта не загрузилась: выключите антивирус';
export const YMAPS_BLOCKED_TOAST_TEXT_TAIL = 'или блокировку рекламы';

export const YmapsBlockedToastContent: React.FC = () => {
  return (
    <span>
      {YMAPS_BLOCKED_TOAST_TEXT} <span className={styles['nowrap']}>{YMAPS_BLOCKED_TOAST_TEXT_TAIL}</span>
    </span>
  );
};

interface IYmapsBlockedToastActionProps {
  onClick(): void;
}

export const YmapsBlockedToastAction: React.FC<IYmapsBlockedToastActionProps> = ({ onClick }) => {
  return (
    <Theme theme="dark" displayContents>
      <span className={styles['action']}>
        <ActionLink fontSize="M" onClick={onClick}>
          Обновить
        </ActionLink>
      </span>
    </Theme>
  );
};
